import { createContext, useContext } from 'react'

export const iconsContext = createContext({
  basePath: '',
})

export const useIconsContext = () => {
  const context = useContext(iconsContext)

  return context
}
